export default function truncateString(s: string, n: number): string {
  if (s.length <= n) return s;
  else return s.slice(0, n).concat("...");
}
